// Component to copy fields from the current form to another form (e.g., in a dialog)
//
// Attributes:
// - `data-copy-from`: Selector for the source form to copy fields from on the element
// - `data-copy-field`: Attribute on input fields to indicate which fields to copy
export default (element: HTMLElement) => {
  const copyFromSelector = element.dataset.copyFrom;
  if (!copyFromSelector) {
    console.error('copyFields component requires data-copy-from attribute');
    return;
  }

  const sourceForm = document.querySelector<HTMLFormElement>(copyFromSelector);
  if (!sourceForm) {
    console.error(`Source form not found for selector: ${copyFromSelector}`);
    return;
  }

  const fieldsToCopy =
    element.querySelectorAll<HTMLInputElement>('[data-copy-field]');
  fieldsToCopy.forEach((field) => {
    const fieldName = field.dataset.copyField;
    if (!fieldName) return;
    const sourceField = sourceForm.querySelector<HTMLInputElement>(
      `[name="${fieldName}"]`,
    );
    if (sourceField) {
      field.value = sourceField.value;
    }
    sourceForm.addEventListener('change', () => {
      if (sourceField) {
        field.value = sourceField.value;
      }
    });
  });
};
